import React, { useEffect } from 'react';
import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';


function SideMenu({ isSidebarOpen, toggleSidebar }) {

    const [openMenu, setOpenMenu] = useState(null);

    const toggleMenu = (menuhome) => {
        setOpenMenu(openMenu === menuhome ? null : menuhome);
    };


    // useEffect(() => {
    //     const sidebar = document.getElementById('side-bar');
    //     const anywhereHome = document.getElementById('anywhere-home');

    //     if (isSidebarOpen) {
    //         sidebar.classList.add('show');
    //         anywhereHome.classList.add('bgshow');
    //     } else {
    //         sidebar.classList.remove('show');
    //         anywhereHome.classList.remove('bgshow');
    //     }
    // }, [isSidebarOpen]);


    return (
        <div>
            <div id="side-bar" className={`side-bar ${isSidebarOpen ? 'show' : ''}`}>
                <button className="close-icon-menu" aria-label="Close Menu" onClick={toggleSidebar}>
                    <i className="far fa-times"></i>
                </button>
                {/* inner menu area desktop start */}
                <div className="rts-sidebar-menu-desktop">
                    <Link className="logo-1" href="index.html">
                        <img
                            className="logo"
                            src="/assets/images/logo.jpeg"
                            alt="finbiz_logo"
                        />
                    </Link>
                    <Link className="logo-2" href="index.html">
                        <img
                            className="logo"
                            src="/assets/images/logo.jpeg"
                            alt="finbiz_logo"
                        />
                    </Link>
                    <Link className="logo-3" href="index.html">
                        <img
                            className="logo"
                            src="/assets/images/logo.jpeg"
                            alt="finbiz_logo"
                        />
                    </Link>
                    <Link className="logo-4" href="index.html">
                        <img
                            className="logo"
                            src="/assets/images/logo.jpeg"
                            alt="finbiz_logo"
                        />
                    </Link>
                    <div className="body d-none d-xl-block">
                        <p className="disc">
                            GLOBAL-SERVICES CONGO Sarlu, société de prestations de services à destination des professionnels,
                            présente au Congo Brazzaville avec direction générale à Pointe-Noire, capitale économique.
                        </p>
                        <div className="get-in-touch">
                            {/* title */}
                            <div className="h6 title">Contactez-Nous</div>
                            {/* title End */}
                            <div className="wrapper">
                                {/* single */}
                                <div className="single">
                                    <i className="fas fa-phone-alt" />
                                    <Link href="tel:+242066123456">+242 06 612 34 56</Link>
                                </div>
                                {/* single ENd */}
                                {/* single */}
                                <div className="single">
                                    <i className="fas fa-envelope" />
                                    <Link href="mailto:contact@global-servicescg.com">contact@global-servicescg.com</Link>
                                </div>
                                {/* single ENd */}
                                {/* single */}
                                <div className="single">
                                    <i className="fas fa-globe" />
                                    <Link href="#">www.globalservices-congo.com</Link>
                                </div>
                                {/* single ENd */}
                                {/* single */}
                                <div className="single">
                                    <i className="fas fa-map-marker-alt" />
                                    <Link href="#">Pointe-Noire, République du Congo</Link>
                                </div>
                                {/* single ENd */}
                            </div>
                        </div>
                    </div>
                    <div className="body-mobile d-block d-xl-none">
                        <nav className="nav-main mainmenu-nav">
                            <ul className="mainmenu metismenu" id="mobile-menu-active">
                                <li className="menu-item">
                                    <NavLink className="menu-link" to={'/'} end>
                                        Accueil
                                    </NavLink>
                                </li>
                                <li className="menu-item">
                                    <NavLink className="menu-link" to={'/qui-sommes-nous'}>
                                        Qui sommes-nous
                                    </NavLink>
                                </li>
                                <li className="menu-item">
                                    <NavLink className="menu-link" to={'/our-service'}>
                                        Services
                                    </NavLink>
                                </li>
                                <li className="menu-item">
                                    <NavLink className="menu-link" to={'/contactus'}>
                                        Contact
                                    </NavLink>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                {/* inner menu area desktop End */}
            </div>


        </div>
    )
}

export default SideMenu